import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tw-w-full tw-border-b tw-border-slate-200/60 tw-bg-white/50 tw-backdrop-blur-md tw-py-3 tw-px-4" }
const _hoisted_2 = { class: "tw-flex tw-flex-col lg:tw-flex-row lg:tw-items-center tw-justify-between tw-gap-4" }
const _hoisted_3 = { class: "tw-flex tw-items-center tw-gap-1.5 tw-bg-slate-100/50 tw-p-1 tw-rounded-xl" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "tw-mt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dispatch_container_view = _resolveComponent("dispatch-container-view")!
  const _component_daily_dispatch = _resolveComponent("daily-dispatch")!
  const _component_ListPage = _resolveComponent("ListPage")!

  return (_openBlock(), _createBlock(_component_ListPage, { variant: "page" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "tw-flex-shrink-0" }, [
            _createElementVNode("div", { class: "tw-flex tw-items-center tw-gap-2" }, [
              _createElementVNode("h1", { class: "tw-text-xl tw-font-bold tw-tracking-tight tw-text-slate-800" }, "Dispatch"),
              _createElementVNode("span", { class: "tw-inline-flex tw-items-center tw-rounded-full tw-bg-emerald-100 tw-px-2 tw-py-0.5 tw-text-[10px] tw-font-medium tw-text-emerald-700" }, " Live ")
            ]),
            _createElementVNode("div", { class: "tw-text-xs tw-text-slate-500" }, "Manage trips and containers")
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['container', 'trips', 'appointments'], (tab) => {
              return _createElementVNode("button", {
                key: tab,
                type: "button",
                class: _normalizeClass(["tw-px-4 tw-py-1.5 tw-text-xs tw-font-semibold tw-rounded-lg tw-transition-all", _ctx.currentView === tab
              ? 'tw-bg-white tw-text-slate-900 tw-shadow-sm'
              : 'tw-text-slate-500 hover:tw-text-slate-700']),
                onClick: ($event: any) => (_ctx.selectDispatchTab(tab))
              }, _toDisplayString(tab.charAt(0).toUpperCase() + tab.slice(1)), 11, _hoisted_4)
            }), 64))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.currentView == 'container')
          ? (_openBlock(), _createBlock(_component_dispatch_container_view, { key: 0 }))
          : (_ctx.currentView == 'trips')
            ? (_openBlock(), _createBlock(_component_daily_dispatch, {
                key: 1,
                isShowingAppointments: false
              }))
            : (_ctx.currentView == 'appointments')
              ? (_openBlock(), _createBlock(_component_daily_dispatch, {
                  key: 2,
                  isShowingAppointments: true
                }))
              : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}